// extracted by mini-css-extract-plugin
export default {"kpi_tile":"KPITile_kpi_tile__J-g4B","kpi_tile_header":"KPITile_kpi_tile_header__VsZnE","kpi_tile_content":"KPITile_kpi_tile_content__yJrj6"};